import React, { Fragment } from 'react';
import {
  useAdvanceFilters,
} from '../../../../share';
import { Row, Col, Button, Divider, Select } from 'antd';
import {
  FormSelect,
  FormInput,
  FormDatePicker,
  CustomText,
} from '../../../../components';
import dayjs from 'dayjs';

const AdvancedFilters: React.FC<any> = ({
  formik,
  filters,
  setFilters,
}: any) => {
  const [filterSelected, setFilterSelected] = React.useState<{
    name: string;
    id: string;
    type: string;
    fetchData?: any[];
  }>();

  const { data: rawFilters } =useAdvanceFilters(
    'good-item-petitions'
  );
  const assetFilters = (rawFilters || []).filter(
    (item) => typeof item.value === 'string' && item.value.startsWith('asset')
  );

  const consumerFilters = (rawFilters || []).filter(
    (item) =>
      typeof item.value === 'string' && item.value.startsWith('consumer-good')
  );


  const normalizeFilters = (filters?: any[]) =>
    (filters || []).map((f) => ({ ...f, id: String(f.value) }));

  const combinedFilters = [
    ...normalizeFilters(assetFilters),
    ...normalizeFilters(consumerFilters),
  ];

  const assetFiltersFormat = normalizeFilters(assetFilters);
  const consumerFiltersFormat = normalizeFilters(consumerFilters);

  const handleAddFilter = () => {
    let item = {
      value: formik.values.filter_value,
      name: '',
      filter: { ...filterSelected },
    };

    if (filterSelected?.type === 'date') {
      item.value = dayjs(formik.values.filter_value).format('YYYY-MM-DD');
    }

    if (filterSelected?.type === 'select') {
      item.name = filterSelected?.fetchData?.find(
        (value) => value.id === formik.values.filter_value
      )?.name;
    }

    setFilters({ ...filters, [formik.values.filter_id]: item });

    setFilterSelected(undefined);
    formik.setFieldValue('filter_value', undefined);
    formik.setFieldValue('filter_id', undefined);
  };

  const handleRemoveFilter = (filterId: string) => {
    const filtersCopy = { ...filters };
    delete filtersCopy[filterId];

    setFilters({ ...filtersCopy });
  };

  return (
    <Fragment>
      <Row
        gutter={[16, 16]}
        align="middle"
      >
        <Col xs={24} sm={12} style={{ display: 'flex', alignItems: 'center' }}>
          <Select
            placeholder="Buscar por campo"
            value={formik.values.filter_id}
            onChange={(value) => {
              setFilterSelected(
                combinedFilters.find(
                  (item) => String(item.id) === String(value)
                )
              );
              formik.setFieldValue('filter_value', '');
              formik.setFieldValue('filter_id', value);
            }}
            style={{ width: '100%', marginTop:15 }}
            allowClear
          >
            <Select.OptGroup label="Bienes de consumo">
              {(consumerFiltersFormat ?? []).map((filter) => (
                <Select.Option key={filter.id} value={filter.id}>
                  {filter.label}
                </Select.Option>
              ))}
            </Select.OptGroup>
            <Select.OptGroup label="Activos fijos">
              {(assetFiltersFormat ?? []).map((filter) => (
                <Select.Option key={filter.id} value={filter.id}>
                  {filter.label}
                </Select.Option>
              ))}
            </Select.OptGroup>
          </Select>
        </Col>
        <Col xs={24} sm={12}>
          {filterSelected?.type === 'select' && (
            <FormSelect
              label=""
              name="filter_value"
              placeholder="Seleccione"
              value={formik.values.filter_value}
              options={filterSelected?.fetchData || []}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'text' && (
            <FormInput
              label={''}
              name="filter_value"
              placeholder="Ingrese valor"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'date' && (
            <FormDatePicker
              label=""
              name="filter_value"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
        </Col>
        <Col
          xs={24}
          style={{ textAlign: 'right', marginTop: 8, width: '100%' }}
        >
          <Button
            type="dashed"
            disabled={
              !formik.values.filter_value || !formik.values.filter_value
            }
            onClick={handleAddFilter}
            style={{ minWidth: 120 }}
          >
            Agregar Filtro
          </Button>
        </Col>
      </Row>
      <Divider />
      {Object.keys(filters).map((filterId: string) => {
        return (
          <Row key={filterId} gutter={[16, 16]} align="middle">
            <Col xs={12}>
              <CustomText
                strong={true}
                text={filters[filterId]?.filter.label}
              />{' '}
            </Col>
            <Col xs={1}>
              <CustomText strong={true} text="=" />{' '}
            </Col>
            <Col xs={7}>
              <CustomText
                text={filters[filterId]?.label || filters[filterId]?.value}
              />{' '}
            </Col>
            <Col xs={4} style={{ textAlign: 'right' }}>
              <Button type="link" onClick={() => handleRemoveFilter(filterId)}>
                Eliminar
              </Button>
            </Col>
          </Row>
        );
      })}
      {!Object.keys(filters).length && (
        <CustomText
          strong={true}
          centered={true}
          text="No tiene filtros agregados"
        />
      )}
    </Fragment>
  );
};

export default AdvancedFilters;
